import React from 'react';
import { useGetCurrentTenantInfo, useGetSandboxSwitchable } from '../../hooks';
import Tooltip from '../tooltip';
import { NavBarLabel } from './navbar.styled';
import { COLORS } from '../../constants/style/color';

type InstanceSwitchProps = {
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>;
};

function InstanceSwitch(props: InstanceSwitchProps) {
  const { handleRequest } = props;
  const { data: currentTenant, isLoading: isCurrentTenantLoading } =
    useGetCurrentTenantInfo(handleRequest);
  const { data: switchableOptionType, isLoading: isSwitchableLoading } = useGetSandboxSwitchable(
    handleRequest,
    undefined,
    Boolean(currentTenant)
  );

  const tenant = currentTenant?.id ?? '';
  const sandBoxName = switchableOptionType?.find((item) => item?.value === tenant)?.label;

  return (
    <>
      {sandBoxName && (
        <Tooltip tooltipText={sandBoxName} variant='dark' size='sm' placement='bottom-center' id='instanceSwitchTooltip'>
          <span className='inline-flex items-center justify-between' id='instanceSwitchContainer'>
            <NavBarLabel
              className='nav-switch-label'
              variant='body'
              color={COLORS.DarkPurple}
              title={sandBoxName}
              fontWeight={500}
              fontSize={14}
              lineClamp={1}
              id='instanceSwitchLabel'
            />
          </span>
        </Tooltip>
      )}
    </>
  );
}

export default InstanceSwitch;
